export default __webpack_public_path__ + "img/cqbVtFvZ.0680c0f8.svg";